import { ISearchQuery } from "../../../shared/hooks/useSearch"
import { IBaseAction } from "../../../shared/types/baseActionTypes"

// State
export interface IAddFormToCaseUIState {
  totalItemsCount: number
  totalPages: number
  resultsPerPage: number
  searchTerm: string
}

// Actions
export interface IFetchFormsForCaseAsyncAction {
  type: string
  payload: ISearchQuery
}

export interface IMarkFormCompleteAction {
  type: string
  payload: {
    formId: string
    caseId: string
  }
}

export enum AddFormToCaseActionTypes {
  FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_PENDING = "@@addPathwayToCase/FETCH_FORM_TEMPATES_FOR_CASE_ASYNC_PENDING",
  FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_SUCCESS = "@@addPathwayToCase/FETCH_FORM_TEMPATES_FOR_CASE_ASYNC_SUCCESS",
  FETCH_FORM_TEMPLATES_FOR_CASE_ASYNC_ERROR = "@@addPathwayToCase/FETCH_FORM_TEMPATES_FOR_CASE_ASYNC_ERROR",
  CREATE_FORM_FOR_CASE_ASYNC_PENDING = "@@addPathwayToCase/CREATE_FORM_FOR_CASE_ASYNC_PENDING",
  CREATE_FORM_FOR_CASE_ASYNC_SUCCESS = "@@addPathwayToCase/CREATE_FORM_FOR_CASE_ASYNC_SUCCESS",
  CREATE_FORM_FOR_CASE_ASYNC_ERROR = "@@addPathwayToCase/CREATE_FORM_FOR_CASE_ASYNC_ERROR",
  MARK_FORM_COMPLETE_ASYNC_PENDING = "@@addPathwayToCase/MARK_CASE_FORM_COMPLETE_ASYNC_PENDING",
  MARK_FORM_COMPLETE_ASYNC_SUCCESS = "@@addPathwayToCase/MARK_CASE_FORM_COMPLETE_ASYNC_SUCCESS",
  MARK_FORM_COMPLETE_ASYNC_ERROR = "@@addPathwayToCase/MARK_CASE_FORM_COMPLETE_ASYNC_ERROR",
}

export interface ICreateFormForCaseAction extends IBaseAction {
  payload: {
    caseId: string
    formTemplateId: string
    meetingCaseId?: string
  }
}
